<div [id]="toastId" class="toast mb-2" role="alert" [ngStyle]="{'border-color': borderColor}" aria-live="assertive"
    data-bs-delay="8000" data-bs-dismiss="toast" data-bs-title="Close" aria-atomic="true">
    <div class="toast-body">
        <div class="alert alert-sm" [ngClass]="'alert-' + level" role="alert">
            <span class="alert-icon"><span class="visually-hidden">{{level}}</span></span>
            <p>{{message}}</p>
        </div>
    </div>
</div>